import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';

interface EmptyDropZoneProps {
  isDraggingOver: boolean;
}

function EmptyDropZone({ isDraggingOver }: EmptyDropZoneProps) {
  return (
    <div
      data-intercom-target="builder-empty-drop-zone"
      className={`py-8 rounded-lg border-2 border-dashed text-center transition-colors ${
        isDraggingOver
          ? 'border-primary bg-primary/10 text-primary'
          : 'border-border text-muted-foreground'
      }`}
    >
      {isDraggingOver ? <T kind="Drop here to add" /> : <T kind="Drag programs here" />}
    </div>
  );
}

export default observer(EmptyDropZone);
